import reducer from "./reducer";
export { default as DigitalWarehouse } from "./components/index";
export { default as digitalWarehouseReducerName } from "./constants";
export default reducer;
